import { IDifferentFunctionCard } from '@/pages/home/interface/home.interface';

interface DifferentFunctionCardProps {
	items: IDifferentFunctionCard[];
}

/**
 * 스텔라만의 차별화 된 기능 카드 컴포넌트
 * @param props: IDifferentFunctionCard
 * @returns JSX.Element
 */

const DifferentFunctionCard = ({ items }: DifferentFunctionCardProps) => {
	return (
		<>
			{items.map((item, index) => (
				<li key={index} className="item-list">
					<figure className={`thumbnail ico${index + 1}`}></figure>
					<div className="title-group">
						<strong className="title" dangerouslySetInnerHTML={{ __html: item.title }}></strong>
						<p className="desc" dangerouslySetInnerHTML={{ __html: item.description }}></p>
					</div>
					<ul className="desc-group">
						{item.subTitles.map((subTitle, subIndex) => (
							<li key={subIndex}>
								<strong className="title" dangerouslySetInnerHTML={{ __html: subTitle }}></strong>
								{item.subDescs[subIndex]?.map((subDesc, descIndex) => (
									<p key={descIndex} className="desc" dangerouslySetInnerHTML={{ __html: subDesc }}></p>
								))}
							</li>
						))}
					</ul>
				</li>
			))}
		</>
	);
};

export default DifferentFunctionCard;
